import printJS from "print-js";
import { MoneyFormatv3 } from "../library/MoneyFormat";
import moment from "moment";

async function getTotal(rows) {
  return rows.reduce(
    (acc, data) => {
      if (data.category === "ledger") {
        const isDebit = data?.balancesign === -1;
        const debitAmount = isDebit ? data?.balance : 0;
        const creditAmount = !isDebit ? data?.balance : 0;
        acc.total += data?.balance || 0;
        acc.credit += creditAmount || 0;
        acc.debit += debitAmount || 0;
      }
      return acc;
    },
    { total: 0, credit: 0, debit: 0 }
  );
}

export async function generateDashboardPrintableTable(
  params,
  tableHeaders,
  tableTitle,
  type = "single",
  companyName,
  companyDetails,
  period,
  toogleAction
) {

  let { hideGroupTotal, hideZeroBalLedger } = toogleAction;

  console.log(params, "params");

  const recursiveRowFn = (rows) => {
    return rows
      .map((row) => {
        if (row.children && row.children.length > 0) {
          return [row, ...recursiveRowFn(row.children)];
        }
        return row;
      })
      .flat();
  };

  const generateTableRows = (rows, headers, level) => {
    return rows
      .map((row) => {
        if (
          !(
            hideZeroBalLedger &&
            row?.balance === 0 &&
            row?.category === "ledger"
          )
        ) {
          const isGroupRow =
            row.category === "group" || row?.category === "Category";

          const fontWeight = isGroupRow ? "bold" : "normal";
          const isDebit = row?.balancesign === -1;

          const debitAmount = isDebit ? row?.balance : 0;
          const creditAmount = !isDebit ? row?.balance : 0;

          return `
          <tr class="${isGroupRow ? " group-row" : ""}">
           ${headers
             .map((header) => {
                              if (header.key === "amount") {
                 if (type === "TrialBalance") {
                   return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `₹ ${MoneyFormatv3(debitAmount) || 0.0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `₹ ${MoneyFormatv3(debitAmount) || 0.0}`
                      : ""
                  }
                </td>
                   <td style="border: 1px solid #000; padding: 8px; text-align: ${
                     header.align || " left"
                   }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `₹ ${MoneyFormatv3(creditAmount) || 0.0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `₹ ${MoneyFormatv3(creditAmount) || 0.0}`
                      : ""
                  }
                </td>
                   `;
                 } else if (type === "Item") {
                   return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${row?.qty || 0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `${row?.qty || 0}`
                      : ""
                  }
                </td>
                   <td style="border: 1px solid #000; padding: 8px; text-align: ${
                     header.align || " left"
                   }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `₹ ${MoneyFormatv3(row?.price) || 0.0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `₹ ${MoneyFormatv3(row?.price) || 0.0}`
                      : ""
                  }
                </td>
                   `;
                 } else {
                   return `
                <td style=" border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                };font-weight:${fontWeight}; ">
                 ${
                   !isGroupRow && type !== "Item"
                     ? `₹ ${MoneyFormatv3(row?.balance) || 0.0}`
                     : ""
                 }
                </td>
                <td style=" border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal && type !== "Item"
                      ? `₹ ${MoneyFormatv3(row?.balance) || 0.0}`
                      : ""
                  }
                </td>
                  `;
                 }
               }
               if (type === "Item" && (header.key === "qty" || header.key === "price")) {
                 if (header.key === "qty") {
                   return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${row?.qty || 0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `${row?.qty || 0}`
                      : ""
                  }
                </td>
                   `;
                 } else if (header.key === "price") {
                   return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                 ${!isGroupRow ? `₹ ${MoneyFormatv3(row?.price) || 0.0}` : ""}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${
                  header.align || " left"
                }; font-weight:${fontWeight};">
                  ${
                    isGroupRow && !hideGroupTotal
                      ? `₹ ${MoneyFormatv3(row?.price) || 0.0}`
                      : ""
                  }
                </td>
                   `;
                 }
               }
               return `
                   <td style="border: 1px solid #000;  padding: 8px; text-align: ${
                     header.align || "left"
                   }; font-weight:${fontWeight};">
                   ${"&nbsp;".repeat(row.level * 4) + row[header.key]}
                   </td>`;
             })
             .join("")}
        </tr>`;
        }
      })
      .join("");
  };

  let printableTable = `
<style>
  @media print {
    .group-row {
      background-color: #d3d3d3 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .openingDiff td {
    color: red !important;
    }

    .totalRow {
      background-color: rgb(152, 152, 152) !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    th {
      background-color: #f4f4f4 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
</style>
<div>
  <h2 style="text-align: center; margin-bottom: 5px;">${companyName}</h2>
  ${companyDetails ? `
    <div style="text-align: center; margin-bottom: 10px;">
      ${companyDetails.line1 ? `<div style="font-size: 12px; margin-bottom: 2px;">${companyDetails.line1}</div>` : ''}
      ${companyDetails.line2 ? `<div style="font-size: 12px; margin-bottom: 2px;">${companyDetails.line2}</div>` : ''}
      ${(() => {
        // Check if location details are already included in line1
        const line1Text = companyDetails.line1 ? companyDetails.line1.toLowerCase() : '';
        const city = companyDetails.city ? companyDetails.city.toLowerCase() : '';
        const district = companyDetails.district ? companyDetails.district.toLowerCase() : '';
        const state = companyDetails.statename ? companyDetails.statename.toLowerCase() : '';
        const pincode = companyDetails.pincode ? companyDetails.pincode : '';
        
        // Check if any of the location details are already in line1
        const cityInLine1 = city && line1Text.includes(city);
        const districtInLine1 = district && line1Text.includes(district);
        const stateInLine1 = state && line1Text.includes(state);
        const pincodeInLine1 = pincode && line1Text.includes(pincode);
        
        // Only show separate location if not already included in line1
        const shouldShowLocation = (companyDetails.city || companyDetails.district || companyDetails.statename || companyDetails.pincode) && 
          !(cityInLine1 && districtInLine1 && stateInLine1 && pincodeInLine1);
        
        if (shouldShowLocation) {
          return `<div style="font-size: 12px; margin-bottom: 2px;">
            ${companyDetails.city ? companyDetails.city : ''}${companyDetails.city && companyDetails.district ? ', ' : ''}${companyDetails.district ? companyDetails.district : ''}${(companyDetails.city || companyDetails.district) && companyDetails.statename ? ', ' : ''}${companyDetails.statename ? companyDetails.statename : ''}${(companyDetails.city || companyDetails.district || companyDetails.statename) && companyDetails.pincode ? ' - ' : ''}${companyDetails.pincode ? companyDetails.pincode : ''}
          </div>`;
        }
        return '';
      })()}
    </div>
  ` : ''}
  <div style="text-align: center; margin-bottom: 10px;">
    <h3 style="margin: 0; font-size: 14px; display: inline;">${tableTitle}</h3>
    <span style="margin: 0 1px; font-size: 14px;">:</span>
    <p style="margin: 0; font-size: 14px; display: inline;">${moment(
    period.startdate * 1000
    ).format("DD-MMM-YYYY")} to ${moment(period.enddate * 1000).format(
      "DD-MMM-YYYY"
  )}</p>
  </div>
</div>

`;

  if (type === "pandl") {
    const flatExpenseFirstRows = recursiveRowFn(params.expenseFirstPart || []);
    const flatIncomeFirstRows = recursiveRowFn(params.incomeFirstPart || []);
    const flatExpenseSecondRows = recursiveRowFn(params.expenseSecondPart || []);
    const flatIncomeSecondRows = recursiveRowFn(params.incomeSecondPart || []);

    const isGrossProfit = params?.grossprotitOrLoss === "profit";
    const isGrossLoss = params?.grossprotitOrLoss === "loss";
    const isNetProfit = params?.protitOrLoss === "profit";
    const isNetLoss = params?.protitOrLoss === "loss";
    const generateExpenseFirstPartRows = () => {
    let rows = '';
    
    rows += `
      <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; line-height: 1.0;">
          Opening Stock
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
          ${MoneyFormatv3(params?.openingStock?.balance) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
    `;
    flatExpenseFirstRows.forEach(row => {
      if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
        const isGroupRow = row.category === "group" || row?.category === "Category";
        const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
        const fontWeight = (isGroupRow || isSpecialGroup) ? "bold" : "normal";
        const fontStyle = (isGroupRow || isSpecialGroup) ? "normal" : "italic";
        const textColor = (isGroupRow || isSpecialGroup) ? "#911B7C" : "inherit";
        
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${(isGroupRow || isSpecialGroup) ? 'margin-bottom: 2px;' : ''}">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>
            ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>` : ''}
          </tr>
        `;
      }
    });
    // Gross Profit c/f
    if (isGrossProfit) {
      rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Gross Profit c/f
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #008000; line-height: 1.0;">
          ${MoneyFormatv3(params?.grossExpenseProfit) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      `;
    }
    return rows;
  };

  const generateExpenseSecondPartRows = () => {
    let rows = '';

    if(isGrossLoss) {
      rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Gross Loss b/d
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${MoneyFormatv3(params?.grossbdIncomeloss * -1) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      `;
    }
    flatExpenseSecondRows.forEach(row => {
      if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
        const isGroupRow = row.category === "group" || row?.category === "profitability" ;
        const fontWeight = isGroupRow  ? "bold" : "normal";
        const fontStyle = isGroupRow ? "normal" : "italic";
        const textColor = isGroupRow ? "#911B7C" : "inherit";
        
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''}">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow  ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>
            ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>` : ''}
          </tr>
        `;
      }
    });

       
   

    return rows;
  };

  const generateIncomeFirstPartRows = () => {
    let rows = '';
    
    rows += `
      <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; line-height: 1.0;">
          Closing Stock
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
          ${MoneyFormatv3(params?.closingStockValue) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
    `;
    flatIncomeFirstRows.forEach(row => {
      if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
        const isGroupRow = row.category === "group" || row?.category === "Category";
        const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
        const fontWeight = (isGroupRow || isSpecialGroup) ? "bold" : "normal";
        const fontStyle = (isGroupRow || isSpecialGroup) ? "normal" : "italic";
        const textColor = (isGroupRow || isSpecialGroup) ? "#911B7C" : "inherit";
        
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${(isGroupRow || isSpecialGroup) ? 'margin-bottom: 2px;' : ''}">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>
            ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>` : ''}
          </tr>
        `;
      }
    });
    
    if(isGrossLoss) {
      rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Gross Loss c/f
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${MoneyFormatv3(params?.grossIncomeloss) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      `;
    }
   
   

    return rows;
  };

  const generateIncomeSecondPartRows = () => {
    let rows = '';

    if (isGrossProfit) {
      rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Gross Profit b/d
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #008000; line-height: 1.0;">
          ${MoneyFormatv3(params?.grossbdExpenseProfit) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      `;
    }
    flatIncomeSecondRows.forEach(row => {
      if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
        const isGroupRow = row.category === "group" || row?.category === "Category";
        const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
        const fontWeight = (isGroupRow || isSpecialGroup) ? "bold" : "normal";
        const fontStyle = (isGroupRow || isSpecialGroup) ? "normal" : "italic";
        const textColor = (isGroupRow || isSpecialGroup) ? "#911B7C" : "inherit";
        
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${(isGroupRow || isSpecialGroup) ? 'margin-bottom: 2px;' : ''}">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
            </td>
            ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${(isGroupRow || isSpecialGroup) ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${(isGroupRow || isSpecialGroup) ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>` : ''}
            </tr>
          `;
        }
      });

   

      return rows;
    };


    printableTable += `
<style>
  @media print {
  @page {
    size: A4 portrait;
    margin: 0.1in;
  }
    body {
      font-family: Calibri, Arial;
      font-size: 9pt;
      line-height: 1.1;
    }
  }
</style>
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
      <tr>
        <th style="width: ${hideGroupTotal ? '32.5%' : '22.5%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Expense
        </th>
        <th style="width: ${hideGroupTotal ? '17.5%' : '13.75%'}; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''} background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal ? `<th style="width: 13.75%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Grp. Total
        </th>` : ''}
        <th style="width: ${hideGroupTotal ? '32.5%' : '22.5%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #C8087F; color: white;">
          Income
        </th>
        <th style="width: ${hideGroupTotal ? '17.5%' : '13.75%'}; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''} background-color: #C8087F; color: white;">
          Amount
        </th>
        ${!hideGroupTotal ? `<th style="width: 13.75%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #C8087F; color: white;">
          Grp. Total
        </th>` : ''}
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateExpenseFirstPartRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateIncomeFirstPartRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- First Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
           Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.firstTotal) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
           Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.firstTotal) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateExpenseSecondPartRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateIncomeSecondPartRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Net Profit/Loss Row -->
      ${isNetProfit ? `
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Net Profit
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #008000; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.netIncomeloss) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      ` : ''}
      ${isNetLoss ? `
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Net Loss
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #FF0000; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.netIncomeloss) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
      ` : ''}

      <!-- Final Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.pandLTotal) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(params?.pandLTotal) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
    </tbody>
  </table>
</div>
`;
  } else if (type === "balancesheet") {
    const flatLiabilities = recursiveRowFn(params.liabilities || []);
    const flatAssets = recursiveRowFn(params.assets || []);

    let { total: totalLiabilities } = await getTotal(params.liabilities);
    let { total: totalAssets } = await getTotal(params.assets);

    const liabilitiesCondition =
      (params?.openingBalanceDiff?.credit !== 0 &&
        params?.openingBalanceDiff?.balance > 0) ||
      (params?.openingBalanceDiff?.credit === 0 &&
        params?.openingBalanceDiff?.balance < 0);
    const assetsCondition =
      (params?.openingBalanceDiff?.credit !== 0 &&
        params?.openingBalanceDiff?.balance < 0) ||
      (params?.openingBalanceDiff?.credit === 0 &&
        params?.openingBalanceDiff?.balance > 0);
    const totalLiabilitiesDiff = liabilitiesCondition
      ? params?.openingBalanceDiff?.balance
      : 0;
    const totalAssetsDiff = assetsCondition
      ? params?.openingBalanceDiff?.balance
      : 0;
    totalLiabilities = totalLiabilities + totalLiabilitiesDiff;
    totalAssets = totalAssets + totalAssetsDiff;

    const generateLiabilitiesRows = () => {
      let rows = '';
      
      flatLiabilities.forEach(row => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
          const isGroupRow = row.category === "group" || row?.category === "Category";
          const fontWeight = isGroupRow ? "bold" : "normal";
          const fontStyle = isGroupRow ? "normal" : "italic";
          const textColor = isGroupRow ? "#911B7C" : "inherit";
          
          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''}">
                ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
              </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
                ${!isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>
              ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>` : ''}
    </tr>
          `;
        }
      });

      if (liabilitiesCondition) {
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${params?.openingBalanceDiff?.name}
        </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${MoneyFormatv3(params?.openingBalanceDiff?.balance) || "0.00"}
        </td>
            ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
          </tr>
        `;
      }

      return rows;
    };

    const generateAssetsRows = () => {
      let rows = '';
      
      flatAssets.forEach(row => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
          const isGroupRow = row.category === "group" || row?.category === "Category";
          const fontWeight = isGroupRow ? "bold" : "normal";
          const fontStyle = isGroupRow ? "normal" : "italic";
          const textColor = isGroupRow ? "#911B7C" : "inherit";
          
          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''}">
                ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
      </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
                ${!isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
        </td>
              ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>` : ''}
    </tr>
          `;
        }
      });

      if (assetsCondition) {
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${params?.openingBalanceDiff?.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${MoneyFormatv3(params?.openingBalanceDiff?.balance) || "0.00"}
            </td>
            ${!hideGroupTotal ? '<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
    </tr>
        `;
      }

      return rows;
    };

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
      <tr>
        <th style="width: ${hideGroupTotal ? '37.5%' : '25%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Liabilities
        </th>
        <th style="width: ${hideGroupTotal ? '12.5%' : '12.5%'}; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''} background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal ? `<th style="width: 12.5%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Grp. Total
        </th>` : ''}
        <th style="width: ${hideGroupTotal ? '37.5%' : '25%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #C8087F; color: white;">
          Assets
        </th>
        <th style="width: ${hideGroupTotal ? '12.5%' : '12.5%'}; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''} background-color: #C8087F; color: white;">
          Amount
        </th>
        ${!hideGroupTotal ? `<th style="width: 12.5%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #C8087F; color: white;">
          Grp. Total
        </th>` : ''}
    </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '75%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '25%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateLiabilitiesRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '75%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '25%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateAssetsRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(totalLiabilities) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        Total
      </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(totalAssets) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </td>
    </tr>
    </tbody>
  </table>
  </div>
  `;
  } else if (type === "TrialBalance") {
    const flatRows = recursiveRowFn(params.rows || []);
    const { credit, debit } = await getTotal(params.rows);
    const totalCredit = params?.openingBalanceDiff.credit + credit;
    const totalDebit = params?.openingBalanceDiff.debit + debit;

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
     <tr>
        <th ${hideGroupTotal ? '' : 'rowspan="2"'} style="width: ${hideGroupTotal ? '60%' : '40%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Particular
        </th>
        ${hideGroupTotal ? `
        <th style="width: 20%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Debit
        </th>
        <th style="width: 20%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Credit
        </th>
        ` : `
        <th colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; background-color: #911B7C; color: white;">
          Debit
        </th>
        <th colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Credit
        </th>
        `}
    </tr>
    ${!hideGroupTotal ? `
    <tr>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Amount
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Grp. Total
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Amount
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Grp. Total
        </th>
    </tr>
    ` : ''}
    </thead>
    <tbody>
      ${flatRows.map(row => {
        if (hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger") {
          return '';
        }
        
        const isGroupRow = row.category === "group" || row?.category === "Category";
        const fontWeight = isGroupRow ? "bold" : "normal";
        const fontStyle = isGroupRow ? "normal" : "italic";
        const textColor = isGroupRow ? "#911B7C" : "inherit";
        const isDebit = row?.balancesign === -1;
        const isCredit = row?.balancesign === 1;
        
        if (hideGroupTotal) {
          // When hideGroupTotal is true, show balance directly in Debit or Credit column
          // But hide group total amounts - only show amounts for ledger rows
          const debitValue = isGroupRow ? "" : (isDebit ? MoneyFormatv3(row?.balance) || "0.00" : "--");
          const creditValue = isGroupRow ? "" : (isCredit ? MoneyFormatv3(row?.balance) || "0.00" : "--");
          
          return `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''} border-left: 1px solid #000;">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${debitValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; border-right: 1px solid #000;">
              ${creditValue}
            </td>
          </tr>
          `;
        } else {
          // Original logic when hideGroupTotal is false
          return `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''} border-left: 1px solid #000;">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow && isDebit ? MoneyFormatv3(row?.balance) || "0.00" : (!isGroupRow && isCredit ? "--" : "")}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow && isDebit ? MoneyFormatv3(row?.balance) || "0.00" : (isGroupRow && isCredit ? "--" : "")}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow && isCredit ? MoneyFormatv3(row?.balance) || "0.00" : (!isGroupRow && isDebit ? "--" : "")}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0; border-right: 1px solid #000;">
              ${isGroupRow && isCredit ? MoneyFormatv3(row?.balance) || "0.00" : (isGroupRow && isDebit ? "--" : "")}
            </td>
          </tr>
          `;
        }
      }).join('')}
      
      ${params?.openingBalanceDiff?.debit !== 0 ? `
        <tr>
          <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0; border-left: 1px solid #000;">
            ${params?.openingBalanceDiff?.name}
      </td>
          ${hideGroupTotal ? `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${MoneyFormatv3(params?.openingBalanceDiff?.debit) || "0.00"}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0; border-right: 1px solid #000;">
            --
          </td>
          ` : `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${MoneyFormatv3(params?.openingBalanceDiff?.debit) || "0.00"}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; border-right: 1px solid #000;"></td>
          `}
        </tr>
      ` : ''}
      
      ${params?.openingBalanceDiff?.credit !== 0 ? `
        <tr>
          <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0; border-left: 1px solid #000;">
            ${params?.openingBalanceDiff?.name}
          </td>
          ${hideGroupTotal ? `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0; border-right: 1px solid #000;">
            ${MoneyFormatv3(params?.openingBalanceDiff?.credit) || "0.00"}
          </td>
          ` : `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${MoneyFormatv3(params?.openingBalanceDiff?.credit) || "0.00"}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; border-right: 1px solid #000;"></td>
          `}
        </tr>
      ` : ''}

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        ${hideGroupTotal ? `
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          ${MoneyFormatv3(totalDebit) || "0.00"}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; border-right: 1px solid #000;">
          ${MoneyFormatv3(totalCredit) || "0.00"}
        </td>
        ` : `
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          ${MoneyFormatv3(totalDebit) || "0.00"}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">--</td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          ${MoneyFormatv3(totalCredit) || "0.00"}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">--</td>
        `}
    </tr>
    </tbody>
    </table>
</div>
    `;
  } else if (type === "Item") {
    const flatRows = params?.rows || [];
    
    // Calculate totals for Items
    const itemTotals = flatRows.reduce(
      (acc, row) => {
        if (row.category === "Item") {
          acc.totalQty += row.qty || 0;
          acc.totalPrice += row.price || 0;
        }
        return acc;
      },
      { totalQty: 0, totalPrice: 0 }
    );
    
    const generateItemRows = () => {
      let rows = '';
      
      flatRows.forEach(row => {
        const isGroupRow = row.category === "Category";
        const fontWeight = isGroupRow ? "bold" : "normal";
        const fontStyle = isGroupRow ? "normal" : "italic";
        const textColor = isGroupRow ? "#911B7C" : "inherit";
        
        const isGoodsType = row.type === "GOODS";
        const unitValue = !isGroupRow && isGoodsType ? (row.unit || "") : (!isGroupRow && !isGoodsType ? "--" : "");
        const qtyValue = !isGroupRow && isGoodsType ? (row.qty || 0) : (!isGroupRow && !isGoodsType ? "--" : "");
        const ledgerValue = !isGroupRow && isGoodsType ? (MoneyFormatv3(row.price) || "0.00") : (!isGroupRow && !isGoodsType ? "--" : "");
        const groupValue = isGroupRow && !hideGroupTotal && isGoodsType ? (MoneyFormatv3(row.price) || "0.00") : (isGroupRow && !hideGroupTotal && !isGoodsType ? "--" : "");
        
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''}">
              ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: center; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${unitValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${qtyValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
              ${ledgerValue}
            </td>
            ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${groupValue}
            </td>` : ''}
          </tr>
        `;
      });

      return rows;
    };
    
    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <colgroup>
      <col style="width: ${hideGroupTotal ? '40%' : '30%'};">
      <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
      <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
      <col style="width: ${hideGroupTotal ? '0%' : '15%'};">
      ${!hideGroupTotal ? '<col style="width: 15%;">' : ''}
    </colgroup>
    <thead>
      <tr>
        <th style="padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Items
        </th>
        <th style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Unit
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Qty
        </th>
        <th ${hideGroupTotal ? 'style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;"' : 'colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;"'}>
          Total value
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '4' : '5'}" style="width: 100%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '40%' : '30%'};">
              <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
              <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
              <col style="width: ${hideGroupTotal ? '0%' : '15%'};">
              ${!hideGroupTotal ? '<col style="width: 15%;">' : ''}
            </colgroup>
            <tbody>
              ${generateItemRows()}
            </tbody>
          </table>
        </td>
      </tr>
        
      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: center; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(itemTotals.totalPrice) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
      </tr>
    </tbody>
    </table>
</div>
    `;
  } else {
    // For single tables like Receivables, Payables
    const flatRows = recursiveRowFn(params.rows || []);
    const { total } = await getTotal(params.rows);

    const generateSingleTableRows = () => {
      let rows = '';
      
      flatRows.forEach(row => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === "ledger")) {
          const isGroupRow = row.category === "group" || row?.category === "Category";
          const fontWeight = isGroupRow ? "bold" : "normal";
          const fontStyle = isGroupRow ? "normal" : "italic";
          const textColor = isGroupRow ? "#911B7C" : "inherit";
          
          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''}">
                ${"&nbsp;".repeat((row.level || 0) * 8) + row.name}
              </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
                ${!isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>
              ${!hideGroupTotal ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'}; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? MoneyFormatv3(row?.balance) || "0.00" : ""}
              </td>` : ''}
            </tr>
          `;
        }
      });

      return rows;
    };

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
     <tr>
        <th style="width: ${hideGroupTotal ? '66.67%' : '50%'}; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          ${type}
        </th>
        <th style="width: ${hideGroupTotal ? '33.33%' : '25%'}; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''} background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal ? `<th style="width: 25%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Grp. Total
        </th>` : ''}
    </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 100%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '66.67%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '33.33%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateSingleTableRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        Total
      </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''}">
          ${MoneyFormatv3(total) || "0.00"}
        </td>
        ${!hideGroupTotal ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>' : ''}
    </tr>
    </tbody>
    </table>
</div>
    `;
  }

  printJS({
    printable: printableTable,
    type: "raw-html",
    header: `<h3 style="text-align: center;">${tableTitle}</h3>`,
    style: `
      @page {
        size: A4 portrait;
        margin: 0.1in;
      }
      body {
        font-family: Calibri, Arial;
        font-size: 9pt;
        line-height: 1.1;
      }
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="background-color"] {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="#911B7C"] {
        background-color: #911B7C !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="#C8087F"] {
        background-color: #C8087F !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      .header-purple {
        background-color: #911B7C !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      .header-pink {
        background-color: #C8087F !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `,
    scanStyles: true,
    targetStyles: ['*'],
    ignoreElements: [],
    documentTitle: tableTitle,
    showModal: true,
    modalMessage: 'Preparing document for printing...',
    onPrintDialogClose: () => {},
    onError: (e) => {
      console.error('Print error:', e);
    }
  });
}
